export default __webpack_public_path__ + "static/media/back_pad1.89f1c16c.png";